<template>
  <v-layout>
    <v-flex>
      <v-card>
        <v-container>
          <v-row align="center" class="system-row">
            <v-col cols="4">
              {{ $t('time') }}
            </v-col>
            <v-col cols="8">
              <div id="076248f8" class="d-inline-flex">{{ currentTime }}</div>
            </v-col>
          </v-row>
          <v-row align="center" class="system-row">
            <v-col cols="4">
              {{ $t('version') }}
            </v-col>
            <v-col cols="8">
              <div id="8cd68971" class="d-inline-flex">{{ version }}</div>
            </v-col>
          </v-row>
          <template v-if="licenseInfo">
            <v-row align="center" class="system-row">
              <v-col cols="4">
                {{ $t('licenseInfo.licenseType') }}
              </v-col>
              <v-col cols="8">
                <div id="8cd68971" class="d-inline-flex">{{ licenseInfo.licenseType }}</div>
              </v-col>
            </v-row>
            <v-row align="center" class="system-row">
              <v-col cols="4">
                {{ $t('licenseInfo.productOwner') }}
              </v-col>
              <v-col cols="8">
                <div id="8cd68971" class="d-inline-flex">{{ licenseInfo.productOwner }}</div>
              </v-col>
            </v-row>
            <v-row align="center" class="system-row">
              <v-col cols="4">
                {{ $t('licenseInfo.productKey') }}
              </v-col>
              <v-col cols="8">
                <div id="8cd68971" class="d-inline-flex">{{ licenseInfo.productKey }}</div>
              </v-col>
            </v-row>
            <v-row v-if="licenseInfo.endOfSupport" align="center" class="system-row">
              <v-col cols="4">
                {{ $t('licenseInfo.endOfSupport') }}
              </v-col>
              <v-col cols="8">
                <div id="8cd68971" class="d-inline-flex">{{ endOfSupport }}</div>
              </v-col>
            </v-row>
          </template>
          <v-row v-if="canDownloadLog" align="center" class="system-row">
            <v-col cols="4">
              {{ $t('logFiles') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">
                <v-select
                  v-model="selectedLogFile"
                  class="mr-3" :items="logFileList"
                  :label="$t('select') +' ' + $t('logFileName')+`*`"
                ></v-select>
              </div>
              <v-btn id="21c500a9" @click="downloadLogFile">
                <v-icon left>mdi-download</v-icon>
                {{ $t('download') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row v-if="isAdmin" align="center" class="system-row">
            <v-col cols="4">
              {{ $t('loggerKeystore') }}
            </v-col>
            <v-col cols="8">
              <div class="d-inline-flex">
                <v-select
                  id="7f696719"
                  v-model="selectedLoggerKeystoreName"
                  class="mr-3" :items="keyStoreNameList"
                  :label="$t('select') +' ' + $t('keyStoreName')+`*`"
                ></v-select>
              </div>
            </v-col>
          </v-row>

          <!-- Audit logs verified, result: [true] -->
          <v-row align="center" class="system-row">
            <v-col cols="4">
              {{ $t('auditLogs') }}
            </v-col>
            <v-col cols="4">
              <v-btn id="1bd8370c" class="mr-5" @click="verifyLogs">
                {{ $t('verify') }}
              </v-btn>
              <v-btn v-if="isSo" id="6c5f5901" @click="signLogs">
                {{ $t('sign') }}
              </v-btn>
            </v-col>
            <!--<v-col v-if="auditLogsVerified !== null" cols="4">
              <div class="d-inline-flex">{{ auditLogsVerified }}</div>
            </v-col>-->
          </v-row>

          <!-- Audit logs signed -->
          <!-- <v-row v-if="isSo" align="center" class="system-row">
            <v-col cols="4">
              {{ $t('auditLogsSigning') }}
            </v-col>
            <v-col cols="8">
              <v-btn @click="signLogs">
                {{ $t('signing') }}
              </v-btn>
            </v-col>
          </v-row> -->

          <v-row v-if="isAdmin" align="center" class="system-row">
            <v-col cols="4">
              {{ 'SSL' }}
            </v-col>
            <v-col cols="8">
              <v-btn id="cb2df0c8" @click="$refs.pkcs12Uploader.click()">
                <v-icon left>mdi-upload</v-icon>
                {{ 'Upload' + ' ' + $t('sslCert') }}
              </v-btn>
              <input
                id="053d3195"
                ref="pkcs12Uploader"
                class="d-none"
                type="file"
                accept=".p12"
                @change="sslPkcs12Changed"
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-flex>
    <v-row justify="center">
      <v-dialog v-model="sslPkcs12PasswordDialogShowed" persistent max-width="600">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t('password') }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    id="9af59117"
                    v-model="sslPkcs12Password"
                    :label="$t('password')"
                    type="password"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              id="4eb4d15c"
              color="blue darken-1"
              text
              @click="uploadSslPkcs12"
            >
              {{ $t('ok') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-layout>
</template>

<script>
import server from '@/api/server'
import keystores from '@/api/keystores'
import audit from '@/api/audit'
import moment from 'moment'
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'
import Role from '../../Role'
import { showToastSuccess, showToastError, showConfirmationDialog } from '../../event-bus'

export default {
  name: 'System',
  data() {
    return {
      currentTimeInUnixTime: '',
      currentTimeInIso: '',
      version: '',
      licenseInfo: null,
      logFiles: '',
      loggerKeystoreName: null,
      selectedLoggerKeystoreName: null,
      auditLogsVerified: null,
      keyStoreNameList: [],
      selectedLogFile: null,
      logFileList: [],
      sslPkcs12File: null,
      sslPkcs12Password: null,
      sslPkcs12PasswordDialogShowed: false
    }
  },

  computed: {
    ...mapGetters(['hasRole']),
    isAdmin() {
      return this.hasRole(Role.ADMIN)
    },
    isSo() {
      return this.hasRole(Role.SO)
    },
    canDownloadLog() {
      return this.hasRole(Role.ADMIN) || this.hasRole(Role.OPERATOR) || this.hasRole(Role.AUDITOR)
    },
    currentTime() {
      return moment(this.currentTimeInIso).format()
    },
    endOfSupport() {
      return moment(this.licenseInfo.endOfSupport).format('YYYY-MM-DD')
    }
  },

  watch: {
    async selectedLoggerKeystoreName() {
      this.changeLoggerKeystore()
    }
  },

  async mounted() {
    await server.getCurrentTime()
      .then(resp => {
        this.currentTimeInUnixTime = resp.unixTime
        this.currentTimeInIso = resp.isoDateTime
      })
      .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))

    await server.getVersionInfo()
      .then(resp => {
        this.version = resp.versionString
        this.licenseInfo = resp.licenseInfo
      })
      .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))

    if (this.canDownloadLog) {
      await server.getLogFileList()
        .then(resp => {
          this.logFileList = resp
          if (this.logFileList.includes('server.log')) this.selectedLogFile = 'server.log'
        })
        .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))
    }

    if (this.isAdmin) {
      await audit.getLogger()
        .then(resp => { this.loggerKeystoreName = this.selectedLoggerKeystoreName = resp.keyStoreName })
        .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))

      await keystores.getKeyStoreNames()
        .then(resp => { this.keyStoreNameList = resp })
        .catch(() => showToastError(this.$t('toastMessage.errorWhileRetrievingData')))
    }
  },

  methods: {
    async getLogFileList() {
      this.logFiles = await server.getLogFileList()
    },

    async changeLoggerKeystore() {
      if (this.selectedLoggerKeystoreName != null && this.selectedLoggerKeystoreName !== this.loggerKeystoreName) {
        let conf = await showConfirmationDialog(this.$t('confirmation'), this.$t('dialog.text.changeLoggerKeystore', { keyStoreName: this.selectedLoggerKeystoreName }))
        if (!conf.confirmedValue) {
          return
        }

        try {
          await audit.updateLogger({ keyStoreName: this.selectedLoggerKeystoreName })
          this.loggerKeystoreName = this.selectedLoggerKeystoreName
          showToastSuccess(this.$t('toastMessage.succesfullyUpdated'))
        } catch (error) {
          this.selectedLoggerKeystoreName = this.loggerKeystoreName
          showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
        }
      }
    },

    async downloadLogFile() {
      if (this.selectedLogFile != null) {
        try {
          await FileSaver.saveAs(await server.getLogFile(this.selectedLogFile), this.selectedLogFile)
        } catch (error) {
          showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
        }
      }
    },

    async signLogs() {
      try {
        await audit.signLogs()
        showToastSuccess(this.$t('toastMessage.succesfullyAuditLogsSigned'))
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      }
    },

    async verifyLogs() {
      try {
        let resp = await audit.verifyLogs()
        this.auditLogsVerified = resp.result
        if (this.auditLogsVerified) {
          showToastSuccess(this.$t('toastMessage.succesfullyAuditLogsVerified'))
        } else {
          showToastError(this.$t('toastMessage.errorAuditLogsVerified'))
        }
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      }
    },

    sslPkcs12Changed(e) {
      this.sslPkcs12File = e.target.files[0]
      this.$refs.pkcs12Uploader.value = ''
      this.sslPkcs12PasswordDialogShowed = true
    },

    async uploadSslPkcs12() {
      this.sslPkcs12PasswordDialogShowed = false
      try {
        await server.uploadSslPkcs12(this.sslPkcs12File, this.sslPkcs12Password)
        showToastSuccess(this.$t('toastMessage.succesfullyUpdated'))
      } catch (error) {
        showToastError(this.$t('toastMessage.errorWhileRetrievingData'))
      } finally {
        this.sslPkcs12Password = null
      }
    }
  }

}
</script>

<style>
.system-row {
  min-height: 80px;
}
</style>
